/*
Prompt:
with Nuxt, i want to set ?next url param at some points in navigation. I need to preserve this param between route navigations until sign-in happens. This means, i need to respond to this ?next parameter only after a succesfull sign-in and until then, preserve this param in navigation. How can i do this?
*/

export default defineNuxtPlugin(() => {
    const route = useRoute()
    const router = useRouter()

    // Store the next parameter in session storage when it first appears
    // if (route.query.next && typeof route.query.next === 'string') {
    //     sessionStorage.setItem('pendingNext', route.query.next)
    // }

    // Add navigation guard to preserve the next parameter
    router.afterEach((to, from) => {
        // console.log('> afterEach', sessionStorage.getItem('pendingNext'))
        // const storedNext = sessionStorage.getItem('pendingNext')

        if (route.query.next && typeof route.query.next === 'string') {
            console.log('> setiing pendingNext > sessionStorage', route.query.next)
            localStorage.setItem('pendingNext', route.query.next)
        }

        // // If we have a stored next parameter and the current route doesn't have it
        // if (storedNext) {
        //     // Add it to the query parameters
        //     console.log('> recraft') // TODO: this not happening
        //     // return {
        //     //     ...to,
        //     //     query: { ...to.query, next: storedNext },
        //     // }
        // }
    })
})
